// extracted by mini-css-extract-plugin
export var search = "search-module--search--UKi6U";
export var fadein = "search-module--fadein--T4X9q";